import baseUrl from "./baseUrl";

function loginConfig(data) {
  return { method: "post", url: `${baseUrl}/api/v1/auth/login`, data: data };
}

export default loginConfig;
